import React from "react";
import {
  CustomCheckBox,
  CustomHourMinutePiker,
  CustomHourPiker,
  CustomView,
} from "../../../../../../../components";
import {
  IHourTiming,
  IWeeksDay,
} from "../../../../../../../types/student.interface";

type Props = {
  label?: string;
  onChange: (arg: IWeeksDay) => void;
  defaultValue: IWeeksDay | undefined;
  error?: string;
};

interface ITime {
  hour?: string | number;
  minute?: string | number;
}

const DayInformation = (props: Props) => {
  const undefinedTime = { hour: undefined, minute: undefined };

  return (
    <section className="timing-row">
      <label className="form-week-day-label">{props.label}</label>
      <CustomView.Row className="form-row dropdown form-row-timing">
        <CustomView.Column
          medium={1}
          className="form-colum-timing small-column"
        >
          <CustomCheckBox
            label="تعطیل"
            isChecked={props.defaultValue?.close}
            onChecked={() =>
              props.onChange({
                ...props.defaultValue,
                close: !props.defaultValue?.close,
              })
            }
          />
        </CustomView.Column>
        <CustomView.Column medium={3} className="form-colum-timing">
          <label className="form-label">زمان ورود</label>
          <CustomHourMinutePiker
            time={
              props.defaultValue?.entranceTime
                ? props.defaultValue.entranceTime
                : undefinedTime
            }
            onChangeTime={(event: ITime) =>
              props.onChange({
                ...props.defaultValue,
                entranceTime: { minute: event.minute, hour: event.hour },
              })
            }
            isDisable={props.defaultValue?.close}
          />
        </CustomView.Column>
        <CustomView.Column medium={3} className="form-colum-timing">
          <label className="form-label">زمان خروج</label>

          <CustomHourMinutePiker
            time={
              props.defaultValue?.departTime
                ? props.defaultValue.departTime
                : undefinedTime
            }
            onChangeTime={(event: ITime) =>
              props.onChange({
                ...props.defaultValue,
                departTime: { minute: event.minute, hour: event.hour },
              })
            }
            isDisable={props.defaultValue?.close}
          />

          {/* <CustomHourPiker
            defaultValue={
              props.defaultValue?.departTime
                ? props.defaultValue.departTime
                : undefinedTime
            }
            onChange={(event: IHourTiming) =>
              props.onChange({
                ...props.defaultValue,
                departTime: event,
              })
            }
            inputName="ساعت خروج"
          /> */}
        </CustomView.Column>
        <CustomView.Column medium={3} className="form-colum-timing">
          <label className="form-label">زمان دریافت</label>
          <CustomHourMinutePiker
            time={
              props.defaultValue?.pickupTime
                ? props.defaultValue.pickupTime
                : undefinedTime
            }
            onChangeTime={(event: ITime) =>
              props.onChange({
                ...props.defaultValue,
                pickupTime: { minute: event.minute, hour: event.hour },
              })
            }
            isDisable={props.defaultValue?.close}
          />

          {/* <CustomHourPiker
            defaultValue={
              props.defaultValue?.pickupTime
                ? props.defaultValue.pickupTime
                : undefinedTime
            }
            onChange={(event: IHourTiming) =>
              props.onChange({
                ...props.defaultValue,
                pickupTime: event,
              })
            }
            inputName="ساعت دریافت"
          /> */}
        </CustomView.Column>
        <div className="error">{props.error !== "" && props.error}</div>
      </CustomView.Row>
    </section>
  );
};

export default DayInformation;
